import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ErrorImage from './ErrorImage';

const ErrorMessage = ({ unsupportedType, messageLabel }) => {
  const error = {
    UNSUPPORTED_ROUTE: {
      title: 'error-unsupported-route-title',
      body: 'error-unsupported-route-body',
    },
    EXCEPTION: {
      title: 'error-server-title',
      body: 'error-server-body',
    },
  };

  return <FormattedMessage id={error[unsupportedType][messageLabel]} />;
};

ErrorMessage.propTypes = {
  unsupportedType: PropTypes.string.isRequired,
  messageLabel: PropTypes.string.isRequired,
};

const ErrorTemplate = ({ errorType, createClassNames, style }) => (
  <div
    className={`${createClassNames([
      'container',
      'p-t-3',
      'p-b-9',
      'border-radius-b',
    ])} bg-elevated`}
    role="alert"
  >
    <div
      className={createClassNames(['col-xs-12', 'col-sm-10', 'col-sm-offset-1', 'text-xs-center'])}
    >
      <ErrorImage style={style} />
      <h4 className={createClassNames(['h4', 'm-b-1'])}>
        <ErrorMessage unsupportedType={errorType} messageLabel="title" />
      </h4>
      <p className={createClassNames(['small'])}>
        <ErrorMessage unsupportedType={errorType} messageLabel="body" />
      </p>
    </div>
  </div>
);

ErrorTemplate.propTypes = {
  style: PropTypes.shape({
    // TODO
  }).isRequired,
  errorType: PropTypes.oneOf(['UNSUPPORTED_ROUTE', 'EXCEPTION']).isRequired,
  createClassNames: PropTypes.func.isRequired,
};

export default ErrorTemplate;
